// extracted by mini-css-extract-plugin
export default {"container":"Todos_container__JdQYm","addTodo":"Todos_addTodo__ymqei","ul":"Todos_ul__MUZC-"};